import { render, staticRenderFns } from "./P2POffers.vue?vue&type=template&id=1a203b89&scoped=true&"
import script from "./P2POffers.vue?vue&type=script&lang=js&"
export * from "./P2POffers.vue?vue&type=script&lang=js&"
import style0 from "./P2POffers.vue?vue&type=style&index=0&id=1a203b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a203b89",
  null
  
)

export default component.exports